import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import BaseDialog from "../base/dialogs/BaseDialog.vue";
import FileField from "../base/inputs/FileField.vue";
import { FunctionalLocation, DBFile } from "@/classes";
import { setupApiQueue } from "../base/api-queue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FunctionalLocationImport',
  emits: ["imported"],
  setup(__props, { expose: __expose, emit: __emit }) {

const dialog = ref(false);
const file = ref<DBFile | null>(null);

const open = () => {
  dialog.value = true;
};

const emit = __emit;

__expose({ open });

const { queueApiAction, loading } = setupApiQueue();

const upload = () => {
  queueApiAction(async () => {
    if (file.value !== null) {
      await FunctionalLocation.importList(file.value.id);
      emit("imported");
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(BaseDialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
    persistent: !!_unref(loading),
    loading: !!_unref(loading),
    "max-width": "500",
    title: "Import Functional Locations"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        color: "primary",
        loading: !!_unref(loading),
        flat: "",
        disabled: file.value === null,
        onClick: upload
      }, {
        default: _withCtx(() => [
          _createTextVNode("Import")
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(FileField, {
        modelValue: file.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((file).value = $event)),
        disabled: !!_unref(loading),
        variant: "outlined",
        density: "compact"
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _: 1
  }, 8, ["modelValue", "persistent", "loading"]))
}
}

})